import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from '../../auth/authentication.service';
import { PortalService } from '../portal.service';

@Component({
    selector: 'portal-header',
    templateUrl: './portal-header.component.html',
    styleUrls: ['./portal-header.component.scss']
})
export class PortalHeaderComponent implements OnInit {

    public products: any[] = [];
    public right_side_bar: boolean;
    constructor(public translate: TranslateService,          
                private authenticationService: AuthenticationService,
                private portalService: PortalService) {

    }

    ngOnInit() {
        this.portalService.resetLanguage();
    }

    logout() {
        this.portalService.logout();
    }
}
